export default "__VITE_ASSET__CvTfqVHn__"